// Banner click tracking (view tracking disabled for now)
export const BannerTracking = {
  initialized: false,
  clickHandler: null,

  init() {
    if (this.initialized) return;
    this.initialized = true;

    // Listen for Turbolinks navigation
    document.addEventListener('turbolinks:load', () => {
      this.attachClickListeners();
    });

    // Initial page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.attachClickListeners();
      });
    } else {
      this.attachClickListeners();
    }
  },

  attachClickListeners() {
    // Remove old listener to prevent duplicates
    if (this.clickHandler) {
      document.removeEventListener('click', this.clickHandler);
    }

    // Single delegated listener for ALL banner clicks
    this.clickHandler = (event) => {
      // Check if clicked element is inside a banner link
      const link = event.target.closest('[data-banner-id] a');
      if (!link) return;

      const banner = link.closest('[data-banner-id]');
      if (!banner) return;

      const bannerId = banner.dataset.bannerId;
      this.trackClick(bannerId);
    };

    // Attach single listener to document
    document.addEventListener('click', this.clickHandler);
  },

  trackClick(bannerId) {
    // Use sendBeacon for reliable tracking even during navigation
    const formData = new FormData();
    formData.append('authenticity_token', this.getCsrfToken());
    navigator.sendBeacon(`/api/v1/banners/${bannerId}/click`, formData);
  },

  getCsrfToken() {
    const element = document.querySelector('[name="csrf-token"]');
    return element ? element.content : '';
  }
};


